<template>
  <div class="admin-login-overlay">
    <div class="login-card">
      <div class="login-header">
        <span class="login-logo">🛒</span>
        <h2 class="login-title">管理后台登录</h2>
        <p class="login-subtitle">欢乐购商城 · 商家管理端</p>
      </div>

      <div class="login-body">
        <div class="login-field">
          <span class="field-icon">👤</span>
          <input
            v-model="username"
            type="text"
            placeholder="请输入管理员用户名"
            autocomplete="username"
            @keyup.enter="handleLogin"
          />
        </div>
        <div class="login-field">
          <span class="field-icon">🔒</span>
          <input
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            placeholder="请输入密码"
            autocomplete="current-password"
            @keyup.enter="handleLogin"
          />
          <span class="field-toggle" @click="showPassword = !showPassword">
            {{ showPassword ? '🙈' : '👁️' }}
          </span>
        </div>
        <div class="login-field captcha-field">
          <span class="field-icon">🛡️</span>
          <input
            v-model="captchaCode"
            type="text"
            maxlength="4"
            placeholder="请输入图形验证码"
            autocomplete="off"
            @keyup.enter="handleLogin"
          />
          <img
            v-if="captchaImg"
            :src="captchaImg"
            class="captcha-img"
            alt="验证码"
            title="点击刷新"
            @click="refreshCaptcha"
          />
          <span v-else class="field-toggle" @click="refreshCaptcha">🔄</span>
        </div>

        <button class="login-btn" :disabled="loading" @click="handleLogin">
          <span v-if="loading" class="spinner"></span>
          {{ loading ? '登录中...' : '登 录' }}
        </button>

        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminLogin',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    captchaImg: {
      type: String,
      default: ''
    },
    captchaKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      username: '',
      password: '',
      showPassword: false,
      captchaCode: ''
    }
  },
  watch: {
    captchaImg () {
      // 验证码刷新后清空已输入的验证码
      this.captchaCode = ''
    }
  },
  methods: {
    refreshCaptcha () {
      this.$emit('refresh-captcha')
    },
    handleLogin () {
      if (!this.username.trim()) {
        this.$toast('请输入用户名')
        return
      }
      if (!this.password) {
        this.$toast('请输入密码')
        return
      }
      if (!this.captchaCode) {
        this.$toast('请输入图形验证码')
        return
      }
      this.$emit('login', {
        username: this.username.trim(),
        password: this.password,
        captchaCode: this.captchaCode.trim(),
        captchaKey: this.captchaKey
      })
    }
  }
}
</script>

<style lang="less" scoped>
.admin-login-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-card {
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
  overflow: hidden;

  .login-header {
    padding: 36px 24px 20px;
    text-align: center;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);

    .login-logo {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 64px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.2);
      font-size: 32px;
      margin-bottom: 12px;
    }
    .login-title {
      color: #fff;
      font-size: 20px;
      font-weight: 700;
      margin: 0 0 4px;
      letter-spacing: 1px;
    }
    .login-subtitle {
      color: rgba(255, 255, 255, 0.8);
      font-size: 13px;
      margin: 0;
    }
  }

  .login-body {
    padding: 28px 24px 24px;

    .login-field {
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      padding: 0 14px;
      height: 48px;
      transition: all 0.2s;

      &:focus-within {
        border-color: #6366f1;
        box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
      }

      .field-icon {
        margin-right: 10px;
        font-size: 16px;
        opacity: 0.6;
      }
      input {
        flex: 1;
        border: none;
        outline: none;
        font-size: 15px;
        color: #1a1a2e;
        background: transparent;
        &::placeholder { color: #9ca3af; }
      }
      .field-toggle {
        cursor: pointer;
        font-size: 16px;
        opacity: 0.6;
        &:hover { opacity: 1; }
      }
      .captcha-img {
        height: 30px;
        border-radius: 6px;
        cursor: pointer;
        border: 1px solid #e5e7eb;
        flex-shrink: 0;
      }
    }

    .login-btn {
      width: 100%;
      height: 48px;
      border: none;
      border-radius: 10px;
      background: linear-gradient(135deg, #6366f1, #8b5cf6);
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 4px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;

      &:hover { transform: translateY(-1px); box-shadow: 0 8px 20px rgba(99, 102, 241, 0.35); }
      &:active { transform: scale(0.98); }
      &:disabled { opacity: 0.6; cursor: not-allowed; }

      .spinner {
        width: 16px;
        height: 16px;
        border: 2px solid rgba(255, 255, 255, 0.4);
        border-top-color: #fff;
        border-radius: 50%;
        margin-right: 8px;
        animation: spin 0.8s linear infinite;
      }
    }

    .login-tip {
      margin-top: 16px;
      text-align: center;
      font-size: 13px;
      color: #9ca3af;
    }
  }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 480px) {
  .login-card { max-width: 100%; }
}
</style>
